// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup-module--popup--2_dv1","popupCloseBtn":"popup-module--popup-close-btn--31Fn5","popupImg":"popup-module--popup-img--3kvYL"};